import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Box, Fade, Modal, Typography, Backdrop} from "@mui/material";
import MyImgRound from "./MyImgRound.js";
import {word} from '../word.js'
import BlueButton from "../components/BlueButton/BlueButton.js";
import Api from "../Api.js";
import Select from "react-select";
import {useParams} from "react-router-dom";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 600 ? 400 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: 500,
    overflow: 'auto',
    maxHeight: '97vh'
};
const customStyles = {
    menu: (provided) => ({
        ...provided,
        position: 'absolute',
        zIndex: 9999,
        maxHeight: 300,
    }),
    menuPortal: (base) => ({...base,margin:0, padding:10, zIndex: 9999}), // Ensures portal menu is above modal
};

function AddManToCompany({setOpen, open,setData, data, setOnly,setAccount}) {
    const [accountant, setAccountant] = useState([]);
    const [staff, setStaff] = useState([]);
    const params = useParams()
    const {id} = params;
    useEffect(() => {
        (async () => {
            try {
                const {data} = await Api.getAllStuff()
            setStaff(data.results.map(s => ({
                value: s.url,
                user: s.user,
                url: s.url,
                image: s.image,
                label: s.user.first_name
            })))
            } catch (error) {
                
            }
        })()
    }, []);

    useEffect(() => {
        if(data.accountant){
            const urlArray = Object.values(data.accountant).map(l => l.url);
            setAccountant(urlArray)
        }

    }, [data]);

    const CustomMultiValue = (props) => {
        const { data, removeProps } = props; // Extract selected item data

        return (
            <div
                style={{margin:'5px 0',padding:10}}
                className={"employee-name-sected employee-name justify-content-between align-content-start"}
                >
                <div className="d-flex ">
                    <MyImgRound image={data.image}/>
                    <div>{data.user.first_name}<br/> {data.user.last_name}</div>
                </div>
                <span {...removeProps} style={{ marginLeft: "5px", cursor: "pointer", fontSize:20,color:'#868686' }}>×</span>
            </div>
        )
    };

    const Option = (props) => {
        const {data, innerRef,selectOption, innerProps} = props;
        return (

            <div
                ref={innerRef} {...innerProps}
                style={{margin:'5px 0',padding:10}}
                className={"employee-name"}
                onClick={() => {
                    selectOption(data)
                }}>
                <MyImgRound image={data.image}/>
                <div>{data.user.first_name}<br/> {data.user.last_name}</div>
            </div>
        );
    }
    const AddAccountantCompanyHandler = async () => {
        try{
            const company = {
                id: data.id,
                name: data.name,
                client: data.client.url,
                subscribe: data.subscribe,
                accountant: accountant,
                HVHH: data.HVHH,
                address: data.address,
                url: data.url
            };
            await Api.updateCompanies(data.id,company)
            const com = await Api.companySingle(id)
            setData(com.data)
            setOpen(false)
        }catch (e) {
            console.log(e)
        }
    }
    const handleSelectChange = useCallback(async (ev) => {
        if(setOnly){
            setData(prev => ({...prev,accountant:ev[0].url,
                accountant_first_name:ev[0].user.first_name,
                accountant_image:ev[0].image,
                accountant_last_name:ev[0].user.last_name,
                accountant_user_id:ev[0].user.id,}))
            setAccount(ev[0])
            setOpen(false)
            return
        }
        const urlArray = Object.values(ev).map(l => l.url);
        setAccountant(urlArray)
    },[setOnly,data])
    const selectRef = useRef(null);
    const [menuIsOpen, setMenuIsOpen] = useState(true);
    useEffect(() => {
        // Focus the input
        if (selectRef.current) {
            selectRef.current.focus();

            // Open the menu
            selectRef.current.onMenuOpen(); // opens dropdown
        }
    }, []);

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className='employee-name-cont d-flex w-100 justify-content-center'>
                        <Select
                            ref={selectRef}
                            autoFocus
                            menuIsOpen={menuIsOpen}
                            onMenuOpen={() => setMenuIsOpen(true)}
                            onMenuClose={() => setMenuIsOpen(false)}
                            menuPlacement="auto"
                            menuPosition="fixed"
                            onChange={(ev) => handleSelectChange(ev)}
                            menuPortalTarget={document.body}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            isMulti={true}
                            options={staff}
                            components={{MultiValue: CustomMultiValue,Option: Option}}
                            styles={customStyles}
                            defaultValue={!setOnly?accountant.map(s => ({
                                label:data.accountant.find(m => m.url === s)?.user?.first_name,
                                value: s,
                                user: data.accountant.find(m => m.url === s)?.user,
                                url: s,
                                image: data.accountant.find(m => m.url === s)?.image,
                            })):[]}
                        />
                    </div>
                    <div className="my-user-org-page d-flex align-items-center justify-content-center">
                        {setOnly?null:<BlueButton title={word.append} onChangeValue={AddAccountantCompanyHandler}/>}

                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default AddManToCompany;